const getDomain = () => {
  if (window.location.hostname.indexOf('brandandcelebrities.com') > -1) return "brandandcelebrities.com";

  return "kolsquare.com";
}
const domain = getDomain();


const DEV = {
  api: 'http://api.localdev.com:3000',
  cookieToken: '_kolsquare_api_token_development',
  urls: {
    app: 'http://admin.localdev.com:3003',
    signup: `http://kolsquare.localdev.com:3004/register?redirect_to=${window.location.href}`,
    influenceProfile: `http://influence.localdev.com:3001/profiles/`,
    influence: `http://influence.localdev.com:3001`,
    community: `http://community.localdev.com:3002`,
  },
}

const getRemoteConfig = () => {
  const { hostname, protocol } = window.location;
  return {
    api: `${protocol}//${hostname}:3000`,
    cookieToken: '_kolsquare_api_token_development',
    urls: {
      app: `${protocol}//${hostname}:3003`,
      signup: `${protocol}//${hostname}:3004/register?redirect_to=${window.location.href}`,
      influenceProfile: `${protocol}//${hostname}:3001/profiles/`,
      influence: `${protocol}//${hostname}:3001`,
      community: `${protocol}//${hostname}:3002`,
    },
  };
  };

const STAGING = {
  api: 'https://api-staging.kolsquare.com',
  cookieToken: '_kolsquare_api_token_staging',
  urls: {
    app: `https://admin-staging.${domain}`,
    signup: `https://staging.kolsquare.com/register?redirect_to=${window.location.href}`,
    influenceProfile: `https://influence-staging.kolsquare.com/profiles/`,
    influence: `https://influence-staging.kolsquare.com`,
    community: `https://community-staging.kolsquare.com`,
  },
}

const LAB = {
  api: 'https://api-lab.kolsquare.com',
  cookieToken: '_kolsquare_api_token_lab',
  urls: {
    app: `https://admin-lab.${domain}`,
    signup: `https://lab.kolsquare.com/register?redirect_to=${window.location.href}`,
    influenceProfile: `https://influence-lab.kolsquare.com/profiles/`,
    influence: `https://influence-lab.kolsquare.com`,
    community: `https://community-lab.kolsquare.com`,
  },
}


const PROD = {
  api: 'https://api.kolsquare.com',
  cookieToken: '_kolsquare_api_token',
  urls: {
    app: `https://admin.${domain}`,
    signup: `https://www.kolsquare.com/register?redirect_to=${window.location.href}`,
    influenceProfile: `https://influence.kolsquare.com/profiles/`,
    influence: `https://influence.kolsquare.com`,
    community: `https://community.kolsquare.com`,
  },
}

// ── Squad (per-team) environments ───────────────────────────────────────
// Static allowlist. To add a squad: add its token here, create a `release/<name>`
// CI branch, and set a NETLIFY_SITE_ID_<NAME>_ADMIN CI variable. Nothing else.
const SQUAD_TOKENS = [
  'squad-eevee',
  'squad-ditto',
  'squad-jigglypuff',
  'squad-porygon',
];

// Squads mirror staging, each with its own API/host.
const buildSquadConfig = (squad) => ({
  api: `https://api-${squad}.kolsquare.com`,
  cookieToken: `_kolsquare_api_token_${squad}`,
  urls: {
    app: `https://admin-${squad}.kolsquare.com`,
    signup: `https://${squad}.kolsquare.com/register?redirect_to=${window.location.href}`,
    influenceProfile: `https://influence-${squad}.kolsquare.com/profiles/`,
    influence: `https://influence-${squad}.kolsquare.com`,
    community: `https://community-${squad}.kolsquare.com`,
  },
});

export const ENV_DEV = "env---dev";
export const ENV_REMOTE = "env---remote";
export const ENV_STAGING = "env---staging";
export const ENV_LAB = "env---lab";
export const ENV_PROD = "env---prod";
export const ENV_SQUAD = "env---squad";

const location = window.location.hostname;

// REACT_APP_ENV=staging npm start
const overrideEnv = process.env.REACT_APP_ENV;

// Squad token matched from the current hostname (deployed), if any.
const squadFromHost = SQUAD_TOKENS.find((squad) => location.indexOf(`${squad}.kolsquare.com`) !== -1);
// Token to build from: deployed host, or local `REACT_APP_ENV=squad-eevee` override.
const squadToken = squadFromHost || (SQUAD_TOKENS.includes(overrideEnv) ? overrideEnv : undefined);

export const env = (() => {
  // If ENV is given, use it
  if(overrideEnv) {
    switch (overrideEnv) {
    case 'prod':
      return ENV_PROD;
    case 'staging':
      return ENV_STAGING;
    case 'lab':
      return ENV_LAB;
    case 'dev':
      return ENV_DEV;
    default:
      if (SQUAD_TOKENS.includes(overrideEnv)) return ENV_SQUAD;
      throw new Error(`Incorrect ENV override: ${overrideEnv}`);
    }
  }

  // If no ENV given, infer from URL
  if (location.indexOf('dev-kolsquare-app-') !== -1) return ENV_REMOTE;
  if (
    location.indexOf('localhost') !== -1 ||
    location.indexOf('localdev') !== -1 ||
    location.indexOf('192.168.') !== -1
  )
    return ENV_DEV;
  if (location.indexOf('staging.kolsquare.com') !== -1) return ENV_STAGING;
  if (location.indexOf('lab.kolsquare.com') !== -1) return ENV_LAB;
  if (squadFromHost) return ENV_SQUAD;
  return ENV_PROD;
})();

export const DEV_DEBUG = !overrideEnv && location.includes('localhost');
export const IS_LOCAL_DEV = location.includes('localhost') || location.includes('localdev');

export const conf = {
  ...(env === ENV_REMOTE
    ? getRemoteConfig()
    : env === ENV_DEV
    ? DEV
    : env === ENV_STAGING
    ? STAGING
    : env === ENV_LAB
    ? LAB
    : env === ENV_SQUAD
    ? buildSquadConfig(squadToken)
    : PROD),
  GATracker: process.env.REACT_APP_GA_TRACKER,
  appsignal: process.env.REACT_APP_APPSIGNAL,
  overrideEnv,
};

export const salesforceCompanyUrl = 'https://kolsquare.lightning.force.com/lightning/r/Account/{{sfId}}/view';
